import React from "react"; 
import { makeStyles } from "@material-ui/core/styles";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";
import { Grid, Slider, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    tabContainer: {
        padding: "5px 20px 5px",
    },
    icons: {
        color: theme.palette.dark.main,
    },
    text: {
        fontSize: "11px",
        textAlign: "center", // Para centralizar o texto abaixo da barra
        marginTop: "-15px", // Ajuste para deixar mais perto
    },
}));

const NotificationsVolume = ({ volume, setVolume }) => {
    const classes = useStyles();

    const handleVolumeChange = (value) => {
        setVolume(value);
        localStorage.setItem("volume", value);
    };

    return (
        <div className={classes.tabContainer}>
            <Grid container spacing={2} alignItems="center">
                <Grid item>
                    <VolumeDownIcon className={classes.icons} />
                </Grid>
                <Grid item xs>
                    <Slider
                        value={Number(volume)}
                        aria-labelledby="continuous-slider"
                        step={0.1}
                        min={0}
                        max={1}
                        onChange={(e, value) => handleVolumeChange(value)}
                    />
                </Grid>
                <Grid item>
                    <VolumeUpIcon className={classes.icons} />
                </Grid>
            </Grid>
            <Typography className={classes.text}>
                Volume das notificações
            </Typography>
        </div>
    );
};

export default NotificationsVolume;
